export enum ActivitiesEnum {
    Accept = 'accept',
    Activate = 'activate',
    Allocate = 'allocate',
    Bill = 'bill',
    Cancel = 'cancel',
    Close = 'close',
    Create = 'create',
    CreateAddendum = 'create_addendum',
    CreditNote = 'credit_note',
    CreditNoteCancel = 'credit_note_cancel',
    Deactivate = 'deactivate',
    Delete = 'delete',
    Deposit = 'deposit',
    Devalidate = 'devalidate',
    Download = 'download',
    Duplicate = 'duplicate',
    Justify = 'justify',
    ManageAttachments = 'manage_attachments',
    MarkAsSent = 'mark_as_sent',
    Match = 'match',
    Merge = 'merge',
    Modify = 'modify',
    Next = 'next',
    Post = 'post',
    Previous = 'previous',
    RecordOverpayment = 'record_overpayment',
    RecordPayment = 'record_payment',
    Refuse = 'refuse',
    Remind = 'remind',
    Reopen = 'reopen',
    SalesInvoiceToQuotation = 'sales_invoice_to_quotation',
    Send = 'send',
    Undeposit = 'undeposit',
    Unjustify = 'unjustify',
    Unmatch = 'unmatch',
    Update = 'update',
    Validate = 'validate',
    WriteOff = 'write_off',
}